// test1545
(1545 && 0);
